<template>
	<div class="what-item-box background-what-section padding-16">
		<div  class="font-color-black font-16 font-gilroy font-weight-500">
			<div>
				<section class="display-inline-block">Program</section>

          <div class="checkbox-container float-right">
            <a @click="changeCheckbox()">
              <input class="" type="checkbox" v-model="what_selection.sms">
              <label>{{notification_text}}</label>
            </a>

            <a v-if="condition_connectiion_remove" class="pointer" @click="removeConditionWhat()">
              <img  class="" width="16" height="16" src="../../../../assets/images/icons/solid/automation_remove_circle.svg"/>
            </a>
          </div>
			</div>

      <section class="option_section">
        <v-select class=" background-white match-button-border mt-2" :placeholder="'Pick Option'" :searchable="true" track-by="id"  v-model="what_selection.program" single label="name" :options="program_options" v-validate="'required'" name="program"></v-select>
        <span v-if="errors.first('program')" class="input-error-msg mr-3">Program is required</span>
      </section>

      <div class="mt-2">Start Date</div>
      <section class="option_section">
        <v-select class="background-white match-button-border mt-2"
          :placeholder="'Pick Option'"
          :searchable="true"
          track-by="value"
          v-model="what_selection.start_date_type"
          single label="name"
          :options="start_date_options"
          v-validate="'required'"
          name="start_">
        </v-select>
        <span v-if="errors.first('start_')" class="input-error-msg mb-3">Start Date field is required</span>
      </section>

      <div  :class=[error_margin_start] class="mt-2 flex-fix gap-5">
        <section v-if="start_date_show" 
          :class="{'input-disabled not-allowed': !start_date_show}" 
          class="width-100 display-inline-block option_section ">
          Starting date:
          <!-- <a class="float-right checkbox-container" @click="changeCheckboxEventDate()">
              <input class="" type="checkbox" v-model="what_selection.event_date">
              <label>Use Event Date</label>
          </a> -->
      
          <date-picker
            v-model="what_selection.date_start"
            :range="false"
            :format="'MM-DD-YYYY'"
            class="fit-content mt-2 width-100"
            name="starting_date"
            v-validate="start_date_required" 
            :placeholder="'Pick a date'"
            :range-separator="' to '"
            :lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
            :valueType="'YYYY-MM-DD'">
          </date-picker>
          <span v-if="errors.first('starting_date')" class="input-error-msg">Start Date is required</span>
        </section>
      </div>

      <section v-if="!start_date_show"
        :class="{'input-disabled not-allowed': start_date_show}"
        class="width-100 display-inline-block option_section">
				Plus how many additional days?

          <input placeholder="Set a number" name="add_date"
          class="fit-content mt-2 width-100" type="number" min="0"
          oninput="validity.valid||(value = '');" v-validate="'required'"
					v-model="what_selection.additional_days_on_start" />
         
					<span v-if="errors.first('add_date')" class="input-error-msg">Additional Number is required</span>
			</section>

      <div class="mt-2">Due Date</div>
      <section class="option_section">
        <v-select class="background-white match-button-border mt-2"
          :placeholder="'Pick Option'"
          :searchable="true"
          track-by="value"
          v-model="what_selection.duration"
          single label="name"
          :options="due_date_options"
          v-validate="'required'"
          name="duration_">
        </v-select>
        <span v-if="errors.first('duration_')" class="input-error-msg mb-3">Due Date field is required</span>
      </section>

			<div  :class=[error_margin_duration] class="mt-2 flex-fix gap-5">
				<section v-if="due_date_show" 
          :class="{'input-disabled not-allowed': !due_date_show}" 
          class="width-100 display-inline-block option_section">
					Due date:
        
          <date-picker 
            v-model="what_selection.date_finish"
            :range="false"
            :format="'MM-DD-YYYY'"
            class="fit-content mt-2 width-100"
            name="due_date"
            v-validate="due_date_required" 
            :placeholder="'Pick a date'"
            :range-separator="' to '"
            :lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
            :valueType="'YYYY-MM-DD'">
          </date-picker>
					<span v-if="errors.first('due_date')" class="input-error-msg">Due Date is required</span>
				</section>

        <section v-if="start_date_enter_show"
          :class="{'input-disabled not-allowed': !start_date_enter_show}"
          class="width-100 display-inline-block option_section">
          How many days after the start date?

            <input placeholder="Set a number" name="start_date"
            class="fit-content mt-2 width-100" type="number" min="0"
            oninput="validity.valid||(value = '');" v-validate="'required'"
            v-model="what_selection.days_from_start_date" />
          
            <span v-if="errors.first('start_date')" class="input-error-msg">Start Date Number is required</span>
        </section>

      </div>
		</div>
	</div>
</template>
<script>
export default {
  props: {
    condition_connectiion_remove: {
      type: Boolean,
      required: true
    },
    current_what_elem: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    option_data: {
      required: true
    },
    edit_view: {
      required: true
    },
    state_valid: {
      required: true
    }
  },
  data: function() {
    return {
      what_selection: {
        program: "",
        duration: "",
        start_date_type: "",
        date_start: "",
        date_finish: "",
        sms: 0,
        event_date: 0,
        days_from_start_date:0,
        additional_days_on_start: 0
      },
      start_date_required: 'required'
    };
  },
  computed: {

    event_date_chosen(){
      return this.what_selection.event_date
    },
    notification_text(){
      if (this.option_data[0] && this.option_data[0].inputs) {
        return this.option_data[0].inputs[4].name;
      } else {
        return '';
      }
    },
    program_options() {
      if (this.option_data[0] && this.option_data[0].inputs) {
        this.get_edit_selections();
        return this.option_data[0].inputs[0].data;
      } else {
        return [];
      }
    },
    // THIS IS THE DUE DATE DROPDOWN OPTIONS
    due_date_options() {
      if (this.option_data[0] && this.option_data[0].inputs) {
        this.get_edit_selections();
        return this.option_data[0].inputs[1].data;
      } else {
        return [];
      }
    },
    // THIS IS THE START DATE DROPDOWN OPTIONS
    start_date_options() {
            if (this.option_data[0] && this.option_data[0].inputs) {
        this.get_edit_selections();
        return this.option_data[0].inputs[7].data;
      } else {
        return [];
      }
    },
    start_date_show() {
      if (this.what_selection.start_date_type) {
        if (this.what_selection.start_date_type.id == 2) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    due_date_show() {
      if (this.what_selection.duration) {
        if (this.what_selection.duration.id == 4) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    start_date_enter_show() {
      if (this.what_selection.duration) {
        if (this.what_selection.duration.id == 5) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    due_date_required() {
      if (this.what_selection.duration) {
        if (this.what_selection.duration.id == 4) {
          return "required";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    error_margin_duration() {
      if (this.errors.first("duration_")) {
        return "mt-3";
      } else {
        return "";
      }
    },
        error_margin_start() {
      if (this.errors.first("start_")) {
        return "mt-3";
      } else {
        return "";
      }
    }
  },
  watch: {
    event_date_chosen(val){
      if(val){
        //reset the start date
        this.start_date_required = ''
        this.what_selection.date_start = null
      }else{
        this.start_date_required = 'required'
      }
    },
    edit_view(val) {
      if (val) {
        this.get_edit_selections();
      }
    },
    current_what_elem(val) {
      if (val != this.what_selection) {
        this.what_selection = val;
      }
    },
    "what_selection.duration"(val) {
      if (val && val.id) {
        if (val.id != 4 )  {
          this.what_selection.date_finish = "";
        }
        if (val.id != 5) {
          this.what_selection.days_from_start_date = 0;
        }
      }
    },
    "what_selection.start_date_type"(val) {
      if (val && val.id) {
        if (val.id != 2 )  {
          this.what_selection.date_start = "";
        }
        if (val.id == 2) {
          this.what_selection.additional_days_on_start = 0;
        }
      }
    },
    what_selection: {
      handler(val) {
        setTimeout( () => {
          if (val.program && val.duration && val.start_date_type) {
            this.$validator.validateAll().then(result => {
              this.$emit("validCondition", result, this.index);
              this.$emit("updateConditionWhat", val, this.index);
            });
          }else{
              this.$emit("validCondition", false);
          }
        },500)
  
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.$nextTick(() => {
      //this.cleanMemory()
    });
  },
  created: function() {
    this.get_edit_selections();
  },
  methods: {
    changeCheckboxEventDate(){
      this.what_selection.event_date = !this.what_selection.event_date
      if(this.what_selection.event_date){
        this.what_selection.date_start = null
        setTimeout( () => {
          this.$validator.validateAll().then(result => {
            this.$emit("validCondition", result, this.index);
            this.$emit("updateConditionWhat", this.what_selection, this.index);
         });
        }
        , 500)
        this.start_date_required = ''
      }else{
        this.start_date_required = 'required'
        this.$emit("validCondition", false, this.index);

      }
    },
    changeCheckbox(){
      this.what_selection.sms = !this.what_selection.sms
    },
    get_edit_selections() {
      if (this.edit_view && this.state_valid) {
        this.$store
          .dispatch("getEachAction", { index: this.index })
          .then(res => {
            if (res) {
              this.updateData(res);
            }
          });
      }
    },
    removeConditionWhat() {
      this.$emit("removeConditionWhat", this.current_what_elem);
    },
    updateData(res) {
      this.program_options.forEach(elem => {
        if (elem.id == res.value[0].value) {
          this.what_selection.program = elem;
        }
      });
      this.due_date_options.forEach(elem => {
        if (elem.id == res.value[1].value) {
          this.what_selection.duration = elem;
          this.$forceUpdate();
        }
      });
      this.start_date_options.forEach(elem => {
        if (elem.id == res.value[7].value) {
          this.what_selection.start_date_type = elem;
          this.$forceUpdate();
        }
      });
      res.value.forEach(elem =>{
        if(elem.rule_property_id == 13){
           this.what_selection.event_date = elem.value
           this.$forceUpdate();
        }
        if(elem.rule_property_id == 12){
           this.what_selection.sms = elem.value
        }
        if(elem.rule_property_id == 11){
          if(elem.value && (elem.value != null || elem.value != '') ){
            //duration date is available
            this.what_selection.date_finish = elem.value
          }
        }
        if(elem.rule_property_id == 10){
          if(elem.value && (elem.value != null || elem.value != '') ){
            //duration date is available
            this.what_selection.date_start = elem.value
          }
        }
        if(elem.rule_property_id == 14){
          if(elem.value && (elem.value != null || elem.value != '') ){
            //duration days is available
            this.what_selection.days_from_start_date = elem.value
          }
        }
        if(elem.rule_property_id == 16){
          if(elem.value && (elem.value != null || elem.value != '') ){
            //duration days is available
            this.what_selection.additional_days_on_start = elem.value
          }
        }
      })
    }
  },
  cleanMemory() {
    this.what_selection = {
      program: "",
      duration: "",
      date_start: "",
      date_finish: "",
      sms: 0,
      event_date: 0,
      days_from_start_date:0,
      additional_days_on_start:0
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/automation/automationGroups/WHAT/whatConditionItem.vue